import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleBeginner } from '@/mocks/articles';

export default function BeginnerTipsPage() {
  return <ArticleLayout article={articleBeginner} />;
}